import { LitElement, html, css } from "lit-element";

import {store} from "@stofloos/stores/store";
import {connect} from "pwa-helpers/connect-mixin.js";

import {InputSimpleStyle} from "@stofloos/components/atoms/inputs/input-simple";
import "@stofloos/components/atoms/buttons/button-submit";
import "@stofloos/components/atoms/loaders/sw-fullscreen-spinner";
import "@stofloos/components/atoms/icons/sw-icon";
import { clearForm, formToJSON, getFormElements, validateForm } from "@stofloos/utils/sw-constants";
import { SWTemplateProvider } from "@stofloos/utils/sw-template-provider";

import { createObject, readObjects } from "@stofloos/actions/crud";
import { showToast } from "@stofloos/actions/toast";
import { changePage } from "@stofloos/actions/app";
import { initRequest, searchAll } from "@stofloos/actions/requests";
import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";

import find from "lodash-es/find";
import {localize} from "@stofloos/actions/localize";


// language=CSS
const style = css`
	:host {
		position: relative;
	}
	.input-simple input {
		margin-top: 10px;
		border: 1px solid var(--app-lightgrey);
		border-radius: 25px;
		width: 100%;
	}

	sw-icon {
		--sw-icon-color: var(--app-accent);
	}
	
	.label {
		padding: 8px 16px;
		background-color: var(--app-white);
		border-radius: 24px;
		margin-bottom: 5px;
		margin-right: 5px;
	}
	
	.label sw-icon {
		cursor: pointer;
		margin: 4px 0 0 10px;
	}
	
	.dropdown[sticky] {
		position: absolute;
		background-color: white;
		width: 100%;
		border-radius: 16px;
		z-index: 1;
	}
`;


export let swAutoCompleteCard = new SWTemplateProvider();

swAutoCompleteCard.setTemplate((object, type) => {
	return html`${object.name}`;
});

export class InputAutocomplete extends connect(store)(LitElement) {
	static get styles() {
		return [LayoutFlex,InputSimpleStyle, style];
	}

	static get properties() {
		return {
			label: { type: String },
			formElement: { type: Object },
			endpoint: { type: String },
			searchkey: { type: String },
			searchNumberKey: { type: String },
			requestId: { type: String },
			callback: { type: Object },
			id: { type: String },
			name: { type: String },

			// show cards on init
			active: { type: Boolean },

			multiselect: { type: Boolean },
			disabled: { type: Boolean },
			isLoading: { type: Boolean },

			object: { type: Object },
			objects: {type: Array},
			values: {type: Array},
			params: { type: Object },
			stickyDropdown: { type: Boolean },
		};
	}

	constructor() {
		super();
		this.searchkey = 'name';
		this.searchNumberKey = 'id';
		this.values = [];
	}

	render() {
		return html`
			
			<strong>${this.label}</strong>
			${this.multiselect ? html`
				<div class="layout horizontal wrap">
				
					${this.values && this.values.length > 0 ? html`
						${this.values.map( (value, index) => {
							return html`
								<span class="label layout horizontal">${value[this.searchkey]}<sw-icon @click="${()=> this.removeObject(index)}" icon="times-circle"></sw-icon></span>
								<input type="number" hidden id="${this.name}" name="${this.name}[${index}].id" value="${value.id}"/>
							`
						})}
					` : ``}
				</div>
			` : html`
				<input type="number" hidden id="${this.name}" name="${this.name}" value="${this.object ? this.object.id : ''}"/>
			`}
			 <div class="input-simple">
				<input id="${this.name}_search" required type="text" @focus="${this.onFocus}" @blur="${this.onBlur}" data-requestid="${this.requestId}"  @keyup="${this.findObjects}"  data-columnstring="${this.searchkey}" data-columnnumber="${this.searchNumberKey}" value="${this.object ? localize(this.object[this.searchkey]) : ''}"/>
					
					${this.active && !this.object && this.objects && this.objects.length > 0 ? html`
						<div ?sticky="${this.stickyDropdown}" class="dropdown">
							${this.objects.map(object => {
								return html`
									<div @mousedown="${() => this.setObject(object)}">${swAutoCompleteCard.getTemplate(object, this.endpoint)}</div>
								`
							})}
						</div>
					` : html`
						${!this.object && false ? html`
							<form style="position: absolute; right: 0; top: 0; background-color: #FFFF; z-index: 99;">
								   <button-contained style="margin-top: 1px; border-radius: 0 5px 5px 0;" lowercase>
										<a style="height: 38px;" @mousedown="${this.createObject}"><sw-icon style="--sw-icon-width: 16px;--sw-icon-color:#FFFFFF;" icon="plus-circle"></sw-icon></a>
								   </button-contained>
							</form>
						`: ``}
					`}
					
				<sw-icon style="position: absolute; right: 12px; top:12px; width:12px;" icon="search"></sw-icon>
			</div>
		`;
	}

	stateChanged(state) {
		if (state.crud[this.requestId] && state.crud[this.requestId] !== this.objects) {
			this.objects = state.crud[this.requestId];
		}
	}

	removeObject(index) {
		if(this.multiselect) {
			this.values.splice(index, 1);
			this.values = [...this.values];
		} else {
		}
	}

	setObject(object) {
		this.active = false;
		if(this.multiselect) {
			if(!find(this.values, ['id', object.id])) {
				this.values.push(object);
				this.values = [...this.values];
			}
		} else {
			this.object = {...object};
			this.shadowRoot.getElementById(this.name+"_search").value = localize(object[this.searchkey]);

			let event = new CustomEvent("sw-autocomplete:object-set", {
				detail: {object: this.object, endpoint: this.endpoint },
				bubbles: true,
				composed: true
			});
			this.dispatchEvent(event);

		}
	}

	findObjects(e, type) {
		if(this.params) {
			if(e.target.value) {
				this.params["name"] = e.target.value;
			}
			store.dispatch(readObjects(this.requestId, this.params));
		} else {
			store.dispatch(searchAll(e));
		}
		this.object = null;
	}

	onFocus(e) {
		this.active = true;
		this.shadowRoot.getElementById(this.name+"_search").value = "";
		this.findObjects(e);
	}

	onBlur() {
		if(this.active) {
			this.active = false;

			if (this.multiselect) {
				this.objects = null;
				this.shadowRoot.getElementById(this.name + "_search").value = "";
			} else {
				this.shadowRoot.getElementById(this.name + "_search").value = "";
			}
		}
	}

	createObject() {
		const form = this.formElement.querySelector("form");
		const formElements = getFormElements(form);

		if (!validateForm(formElements)) {
			return;
		}

		const data = formToJSON(formElements);

		this.isLoading = true;
		store
			.dispatch(createObject(this.requestId, data))
			.then(response => {
				this.isLoading = false;
				store.dispatch(showToast(this.callback.message.success));
				store.dispatch(changePage(this.callback.url));
				clearForm(formElements);
			})
			.catch(response => {
				this.isLoading = false;
				store.dispatch(showToast(this.callback.message.error));
			});
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);

		this.requestId = this.endpoint+"AutoComplete";
		store.dispatch(initRequest(this.requestId, this.endpoint));
	}
}

customElements.define("input-autocomplete", InputAutocomplete);
